import type { Tables } from "@/gestionale/integrations/supabase/types";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/gestionale/components/ui/alert-dialog";

interface Props {
  abbonamento: Tables<"abbonamenti"> | null;
  personaNome: string;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export default function DeleteAbbonamentoDialog({ abbonamento, personaNome, onOpenChange, onConfirm, isDeleting }: Props) {
  return (
    <AlertDialog open={!!abbonamento} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Eliminare l'abbonamento?</AlertDialogTitle>
          <AlertDialogDescription>
            Stai per eliminare l'abbonamento di <strong>{personaNome}</strong> al corso <strong>{abbonamento?.corso}</strong>. Questa azione è irreversibile.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isDeleting} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
            {isDeleting ? "Eliminazione..." : "Elimina"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
